/** TODO temporary. will be refactored */

import { SecurityScope } from '../auth/auth.model';
import { AreaItem } from '../location/area.location.model';
import { RegionItem } from '../location/region.location.model';
import { SiteItem } from '../location/site.location.model';

import { Column, Row, Sort, SortOrder } from './experimental.grid';
import { LobItem } from './lob.pi.model';
import { RoleItem } from './role.user.model';
import { CriteriaFormValue } from './search-user.form';
import {
    ColumnID,
    ParameterType,
    StatusType,
    UserSearchResult,
} from './search-user.model';
import { SuperGroupItem } from './supergroup.pi.model';
import { User } from './user.model';

export interface RootState {
    pending: {
        init?: boolean;
        selectUser?: boolean;
        favorite?: { [rowId: string]: boolean }; // userId
        search?: boolean;
    };

    scope?: SecurityScope;

    lobs?: LobItem[];
    regions?: RegionItem[];
    areas?: AreaItem[];
    sites?: SiteItem[];
    superGroups?: SuperGroupItem[];
    roles?: RoleItem[];

    teamColumns?: Column[]; // this is special. it should not be recreated else the entire grid would be invalidated
    teamRows?: Row[];
    teamSortDefs?: Sort[];
    teamGridNeedsLayout?: number; // Date.now(). used for forcing a grid layout

    favoritesColumns?: Column[]; // this is special. it should not be recreated else the entire grid would be invalidated
    favoritesRows?: Row[];
    favoritesSortDefs?: Sort[];
    favoritesGridNeedsLayout?: number; // Date.now(). used for forcing a grid layout

    criteria?: CriteriaFormValue;
    formNeedsUpdate?: number; // Date.now(). used for triggering form.patchValue when criteria changes from the direction of state -> ui
    didInitialSearch?: boolean;
    searchFailed?: boolean;
    searchExceedsMaxCount?: boolean;

    searchColumns?: Column[]; // this is special. it should not be recreated else the entire grid would be invalidated
    searchRows?: Row[];
    searchSortDefs?: Sort[];
    searchGridNeedsLayout?: number; // Date.now(). used for forcing a grid layout

    selectedUserProfile?: User;
    selectedUser?: UserSearchResult;
    selectedUserManager?: UserSearchResult;

    /** TODO revise. this is temporary means of flushing tabs after auth user has changed */
    authUserId?: number;
}

export const defaultCriteria = (): CriteriaFormValue => ({
    statusType: StatusType.ACTIVE,
    parameters: [
        { parameterType: ParameterType.USER_NAME, status: StatusType.ACTIVE },
    ],
});
export const defaultSortDef = (): Sort => ({
    columnId: ColumnID.NAME.toString(),
    order: SortOrder.ASC,
});

export const defaultState = (): RootState => ({
    pending: {},
    teamSortDefs: [defaultSortDef()],
    favoritesSortDefs: [defaultSortDef()],
    criteria: defaultCriteria(),
    searchSortDefs: [defaultSortDef()],
});
